exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.nav[data-v-759a16cc] {\n  text-align: center;\n  margin-top: 10px;\n}\n.nav__item[data-v-759a16cc] {\n    display: inline-block;\n    margin: 0;\n    padding: 0;\n}\n.nav__link[data-v-759a16cc] {\n    position: relative;\n    display: block;\n    color: #000;\n    text-transform: uppercase;\n    text-decoration: none;\n    padding: 10px;\n    background-color: #f05724;\n    color: #fff;\n    font-size: 14px;\n    font-weight: 200;\n}\n.nav__link--active[data-v-759a16cc] {\n      background-color: #d33f0e;\n      font-weight: bold;\n}\n.nav__link--left[data-v-759a16cc] {\n      border-bottom-left-radius: .5em;\n      border-top-left-radius: .5em;\n}\n.nav__link--right[data-v-759a16cc] {\n      border-bottom-right-radius: .5em;\n      border-top-right-radius: .5em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-759a16cc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/TabSection.vue
// module id = 101
// module chunks = 0